export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-50 pt-14 pb-8">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <h4 className="font-heading text-lg text-background-50 mb-3">女神漫画网</h4>
            <p className="text-xs text-foreground-300 leading-relaxed">
              女神漫画网提供海量女神漫画免费全集在线看，支持女神漫画免费下拉式阅读，每日更新追更推荐，畅享流畅手机阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#ranking" className="text-xs text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">热门排行榜</a>
              <a href="#carousel" className="text-xs text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">精选推荐</a>
              <a href="#about" className="text-xs text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">关于我们</a>
              <a href="#faq" className="text-xs text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">漫画分类</h4>
            <div className="flex flex-col gap-2">
              <a href="#index" className="text-xs text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">漫画索引</a>
              <a href="#media" className="text-xs text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">精彩推荐</a>
              <a href="#topics" className="text-xs text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">热门话题</a>
              <a href="#updates" className="text-xs text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">最新更新</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">合作伙伴</h4>
            <p className="text-xs text-foreground-300">暂无合作伙伴展示</p>
          </div>
        </div>

        <div className="border-t border-foreground-700/30 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 女神漫画网 - 免费女神漫画在线下拉式阅读大全
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">回到顶部</a>
            <a href="#contact" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}